import React from "react";
const ReactApexChart = React.lazy(() => import("react-apexcharts"));

const DoughnutChart = ({ graphData }) => {
  const addValue = (item1, item2) => {
    return Math.round(parseFloat(item1) + parseFloat(item2));
  };
  const totalWTFShare = Math.abs(
    addValue(
      parseInt(graphData?.revenue_share_regular_membership?.wtf_share) || 0,
      parseInt(graphData?.cash_flow_other_membership?.total_wtf_share) || 0
    )
  );
  const totalGYMShare = Math.abs(
    addValue(
      parseInt(graphData?.gym_share_final) || 0,
      parseInt(graphData?.cash_flow_other_membership?.total_gym_share) || 0
    )
  );

  const totalSum = totalWTFShare + totalGYMShare;
  const percentageWTFShare =
    totalSum !== 0 ? parseFloat((totalWTFShare / totalSum) * 100) : 0;
  const percentageGYMShare =
    totalSum !== 0 ? parseFloat((totalGYMShare / totalSum) * 100) : 0;

  console.log(percentageWTFShare, " = ", percentageGYMShare);

  const series = [percentageWTFShare, percentageGYMShare];

  const options = {
    chart: {
      width: 400,
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
    },
    labels: ["WTF Share", "Gym Share"],
    legend: {
      formatter: function (val, opts) {
        if (opts.seriesIndex === 0) {
          return "WTF Share - ₹" + series?.[0];
        } else if (opts.seriesIndex === 1) {
          return "Gym Share - ₹" + series?.[1];
        }
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    colors: ["#FF8F6B", "#3D6FD2"],
  };

  return (
    <div id="chart">
      {graphData ? (
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          width={380}
        />
      ) : (
        <span>No Data Found!</span>
      )}
    </div>
  );
};

export default DoughnutChart;
